//include 4 
jQuery(function () {

    var privateFunctions = {
        handleHide: function (element, selectedValue) {
            var switchHide = element.data('switch-hide');
            if (!!switchHide) {
                if (switchHide == selectedValue) {
                    element.addClass('hide');
                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.switchHide, [{
                        hide: true,
                        element: element
                    }]);
                } else {
                    element.removeClass('hide');
                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.switchHide, [{
                        hide: false,
                        element: element
                    }]);
                }
            }
        },
        handleSwitchClass: function (element, selectedValue) {
            var switchClass = element.data('switch-class');
            if (!!switchClass) {
                $.each(switchClass, function (i, value) {
                    element.removeClass(value);
                });
                var newClass = switchClass[selectedValue];
                if (!!newClass) {
                    element.addClass(newClass);
                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.switchClass, [{
                        class: newClass,
                        element: element
                    }]);
                }
            }
        },
        triggerChange(id, alternativeText, newValue, alternativeTitle) {
            var $this = $(`[data-switch-trigger="${id}"]`);
            var values = $this.data('values');
            var formName = $this.data('form-name');
            if (!id || !values)
                return;

            var key = `ppSwitch:${window.location.href}`;
            var stringified = JSON.stringify({
                id: id,
                alternativeText: alternativeText,
                newValue: newValue,
                alternativeTitle: alternativeTitle
            });
            window.sessionStorage.setItem(key, stringified);

            var switches = $(`[data-switch='${id}']`);
            if (!!alternativeText) {
                var oldText = $this.text();
                if (oldText != alternativeText) {
                    $this.text(alternativeText);
                    $this.data('alternative-text', oldText);
                }
            }
            if (!!alternativeTitle) {
                var oldTitle = $this.attr('title');
                if (oldTitle != alternativeTitle) {
                    $this.attr('title', alternativeTitle);
                    $this.data('alternative-title', oldTitle);
                }
            }

            $this.data('selected-value', newValue);
            if (!!formName); {
                var form = $(`[name='${formName}']`);
                if (form.length > 0) {
                    var hiddenSwitchValue = form.find("input[type='hidden'][name='switchValue']");
                    if (hiddenSwitchValue.length == 0) {
                        hiddenSwitchValue = $(`<input type="hidden" name="switchValue" value="${newValue}" />`).appendTo(form);
                    } else {
                        hiddenSwitchValue.val(newValue);
                    }
                }
            }
            var changed = false;
            switches.each(function () {
                privateFunctions.handleHide($(this), newValue);
                privateFunctions.handleSwitchClass($(this), newValue);
                changed = true;
            });
            //*
            if (!!changed) {
                setTimeout(function () {
                    var stickies = $(`.sticky`).each(function () {
                        try{
                            $(this).foundation('_calc', true);
                        }
                        catch(err){}
                    });
                }, 100);
            }
            //*/
            $(".map-container.sticky-container.visibleMap").attr("style","");
        }
    };

    $("[data-switch-trigger]").each(function () {
        var $this = $(this);
        var id = $this.data('switch-trigger');
        var values = $this.data('values');
        if (!id || !values)
            return;
        var initialValue = $this.data('initial-value') || values[0];
        var defaultValue = $this.data('default-value') || values[0];
        var defaultText = $this.data('default-text') || $(`[data-switch-trigger="${id}"]`).text();
        var defaultTitle = $this.data('default-title') || values[0];

        $this.data('selected-value', initialValue);
        var formName = $this.data('form-name');

        var triggerInitial = $this.is("[data-trigger-initial]");

        var triggerChange = function () {
            var alternativeText = $this.data('alternative-text');
            var alternativeTitle = $this.data('alternative-title');
            var oldValue = $this.data('selected-value');
            var otherValues = values.filter(function (v) {
                return v != oldValue;
            });
            var newValue = otherValues[0];
            privateFunctions.triggerChange(id, alternativeText, newValue, alternativeTitle);
        }

        var setDefaultChange = function () {
            privateFunctions.triggerChange(id, defaultText, defaultValue, defaultTitle);
        }

        $this.on("click", function () {
            triggerChange();
        });

        //*
        if (triggerInitial) {
            setTimeout(function () {
                triggerChange();
            }, 100);
        }
        //*/

        window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.switchSetDefault + ":" + id, setDefaultChange);

        var key = `ppSwitch:${window.location.href}`;
        var savedData = window.sessionStorage.getItem(key);
        if (!!savedData) {
            savedData = JSON.parse(savedData);
            privateFunctions.triggerChange(savedData.id, savedData.alternativeText, savedData.newValue, savedData.alternativeTitle);
        }

    });
});